import { render, staticRenderFns } from "./NewUserAdd.vue?vue&type=template&id=57bc30da&scoped=true"
import script from "./NewUserAdd.vue?vue&type=script&lang=js"
export * from "./NewUserAdd.vue?vue&type=script&lang=js"
import style0 from "./NewUserAdd.vue?vue&type=style&index=0&id=57bc30da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc30da",
  null
  
)

export default component.exports